import React, { useEffect } from 'react';

import Sidebar from './Sidebar'//import $ from "jquery";

import { Link } from 'react-router-dom';
import ImageR from '../assets/img/Icons/Icons/image.png'

import ImageQ from '../assets/img/Icons/Icons/imageQ.png'
import ImageC from '../assets/img/Icons/Icons/imagechat.png'
import Barside from '../assets/img/Icons/Icons/Icon-17.png'

import Imgcard1 from '../assets/img/Icons/Icons/cameraI.jpg'
import Footer from './footer'
const Reaward = () => {


    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [])


    return (
        <div>
            <div className="bg-white border shadow  bg-bottom-round">
                <div className="container page17">
                    <div className="row mt-3">
                        <div className="col-sm-1-my17 ">
                            <Sidebar />
                        </div>

                        <div className="col-sm-11-my17 text-center ">
                            <h5 className=" signin1-h1-top  mb-0">Reawards</h5>
                        </div>

                    </div>

                    <div className="row page17-p">
                        <div className="col-sm-12 py-2 ">
                            <hr className="mt-2" />

                            <div className="row  scroll-inner">
                                <div className="col-sm-12">
                                    <p className="text-red text-center">MEMBER #:5887456</p>
                                </div>
                                <div className="col-sm-12 mt-2 mb-1">
                                    <div className="px-3 card-hori-t">
                                        <div className="row ">
                                            <div className="col-sm-4-my px-0">
                                                <div className="reward-card-img-outer-left">
                                                    <img src={Imgcard1} alt="" className="reward-card-img-left" />
                                                </div>
                                            </div>
                                            <div className="col-sm-8-my bg-light card-img-right">
                                                <div className="p-3">
                                                    <p className="mb-0 card-img-right-p1-R">Buy 10 Food Club White sandwich bread, get 1 free digital punchcard</p>
                                                    <div className="row mt-4">
                                                        <div className="col-sm-4 col">
                                                            <p className="mb-0"><small className="font-weight-bold text-secondary-light-gray">10 min</small></p>
                                                        </div>
                                                        <div className="col-sm-8 col">
                                                            <a href="" className="text-decoration-none fw600 card-img-right-p2-R text-red float-right">View Detail</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mt-2 mb-1">
                                    <div className="px-3 card-hori-t">
                                        <div className="row ">
                                            <div className="col-sm-4-my px-0">
                                                <div className="reward-card-img-outer-left">
                                                    <img src={Imgcard1} alt="" className="reward-card-img-left" />
                                                </div>
                                            </div>
                                            <div className="col-sm-8-my bg-light card-img-right">
                                                <div className="p-3">
                                                    <p className="mb-0 card-img-right-p1-R">Buy 10 Food Club White sandwich bread, get 1 free digital punchcard</p>
                                                    <div className="row mt-4">
                                                        <div className="col-sm-4 col">
                                                            <p className="mb-0"><small className="font-weight-bold text-secondary-light-gray">10 min</small></p>
                                                        </div>
                                                        <div className="col-sm-8 col">
                                                            <a href="" className="text-decoration-none fw600 card-img-right-p2-R text-red float-right">View Detail</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mt-2 mb-1">
                                    <div className="px-3 card-hori-t">
                                        <div className="row ">
                                            <div className="col-sm-4-my px-0">
                                                <div className="reward-card-img-outer-left">
                                                    <img src={Imgcard1} alt="" className="reward-card-img-left" />
                                                </div>
                                            </div>
                                            <div className="col-sm-8-my bg-light card-img-right">
                                                <div className="p-3">
                                                    <p className="mb-0 card-img-right-p1-R">Buy 10 Food Club White sandwich bread, get 1 free digital punchcard</p>
                                                    <div className="row mt-4">
                                                        <div className="col-sm-4 col">
                                                            <p className="mb-0"><small className="font-weight-bold text-secondary-light-gray">10 min</small></p>
                                                        </div>
                                                        <div className="col-sm-8 col">
                                                            <a href="" className="text-decoration-none fw600 card-img-right-p2-R text-red float-right">View Detail</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mt-2 mb-1">
                                    <div className="px-3 card-hori-t">
                                        <div className="row ">
                                            <div className="col-sm-4-my px-0">
                                                <div className="reward-card-img-outer-left">
                                                    <img src={Imgcard1} alt="" className="reward-card-img-left" />
                                                </div>
                                            </div>
                                            <div className="col-sm-8-my bg-light card-img-right">
                                                <div className="p-3">
                                                    <p className="mb-0 card-img-right-p1-R">Buy 10 Food Club White sandwich bread, get 1 free digital punchcard</p>
                                                    <div className="row mt-4">
                                                        <div className="col-sm-4 col">
                                                            <p className="mb-0"><small className="font-weight-bold text-secondary-light-gray">10 min</small></p>
                                                        </div>
                                                        <div className="col-sm-8 col">
                                                            <a href="" className="text-decoration-none fw600 card-img-right-p2-R text-red float-right">View Detail</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mt-2 mb-1">
                                    <div className="px-3 card-hori-t">
                                        <div className="row ">
                                            <div className="col-sm-4-my px-0">
                                                <div className="reward-card-img-outer-left">
                                                    <img src={Imgcard1} alt="" className="reward-card-img-left" />
                                                </div>
                                            </div>
                                            <div className="col-sm-8-my bg-light card-img-right">
                                                <div className="p-3">
                                                    <p className="mb-0 card-img-right-p1-R">Buy 10 Food Club White sandwich bread, get 1 free digital punchcard</p>
                                                    <div className="row mt-4">
                                                        <div className="col-sm-4 col">
                                                            <p className="mb-0"><small className="font-weight-bold text-secondary-light-gray">10 min</small></p>
                                                        </div>
                                                        <div className="col-sm-8 col">
                                                            <a href="" className="text-decoration-none fw600 card-img-right-p2-R text-red float-right">View Detail</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mt-2 mb-1">
                                    <div className="px-3 card-hori-t">
                                        <div className="row ">
                                            <div className="col-sm-4-my px-0">
                                                <div className="reward-card-img-outer-left">
                                                    <img src={Imgcard1} alt="" className="reward-card-img-left" />
                                                </div>
                                            </div>
                                            <div className="col-sm-8-my bg-light card-img-right">
                                                <div className="p-3">
                                                    <p className="mb-0 card-img-right-p1-R">Buy 10 Food Club White sandwich bread, get 1 free digital punchcard</p>
                                                    <div className="row mt-4">
                                                        <div className="col-sm-4 col">
                                                            <p className="mb-0"><small className="font-weight-bold text-secondary-light-gray">10 min</small></p>
                                                        </div>
                                                        <div className="col-sm-8 col">
                                                            <a href="" className="text-decoration-none fw600 card-img-right-p2-R text-red float-right">View Detail</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mt-2 mb-1">
                                    <div className="px-3 card-hori-t">
                                        <div className="row ">
                                            <div className="col-sm-4-my px-0">
                                                <div className="reward-card-img-outer-left">
                                                    <img src={Imgcard1} alt="" className="reward-card-img-left" />
                                                </div>
                                            </div>
                                            <div className="col-sm-8-my bg-light card-img-right">
                                                <div className="p-3">
                                                    <p className="mb-0 card-img-right-p1-R">Buy 10 Food Club White sandwich bread, get 1 free digital punchcard</p>
                                                    <div className="row mt-4">
                                                        <div className="col-sm-4 col">
                                                            <p className="mb-0"><small className="font-weight-bold text-secondary-light-gray">10 min</small></p>
                                                        </div>
                                                        <div className="col-sm-8 col">
                                                            <a href="" className="text-decoration-none fw600 card-img-right-p2-R text-red float-right">View Detail</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mt-2 mb-1">
                                    <div className="px-3 card-hori-t">
                                        <div className="row ">
                                            <div className="col-sm-4-my px-0">
                                                <div className="reward-card-img-outer-left">
                                                    <img src={Imgcard1} alt="" className="reward-card-img-left" />
                                                </div>
                                            </div>
                                            <div className="col-sm-8-my bg-light card-img-right">
                                                <div className="p-3">
                                                    <p className="mb-0 card-img-right-p1-R">Buy 10 Food Club White sandwich bread, get 1 free digital punchcard</p>
                                                    <div className="row mt-4">
                                                        <div className="col-sm-4 col">
                                                            <p className="mb-0"><small className="font-weight-bold text-secondary-light-gray">10 min</small></p>
                                                        </div>
                                                        <div className="col-sm-8 col">
                                                            <a href="" className="text-decoration-none fw600 card-img-right-p2-R text-red float-right">View Detail</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mt-2 mb-1">
                                    <div className="px-3 card-hori-t">
                                        <div className="row ">
                                            <div className="col-sm-4-my px-0">
                                                <div className="reward-card-img-outer-left">
                                                    <img src={Imgcard1} alt="" className="reward-card-img-left" />
                                                </div>
                                            </div>
                                            <div className="col-sm-8-my bg-light card-img-right">
                                                <div className="p-3">
                                                    <p className="mb-0 card-img-right-p1-R">Buy 10 Food Club White sandwich bread, get 1 free digital punchcard</p>
                                                    <div className="row mt-4">
                                                        <div className="col-sm-4 col">
                                                            <p className="mb-0"><small className="font-weight-bold text-secondary-light-gray">10 min</small></p>
                                                        </div>
                                                        <div className="col-sm-8 col">
                                                            <a href="" className="text-decoration-none fw600 card-img-right-p2-R text-red float-right">View Detail</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>



                            </div>


                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default Reaward;

